import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOrderPickingSm = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 100 100",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Layer_1",
		"data-name": "Layer 1",
		children: [
			/* @__PURE__ */ _jsx("polygon", {
				className: "icon-white",
				points: "22.97 47.19 37.46 55.66 37.77 72.25 22.97 80.84 8.27 72.27 8.27 56.27 22.97 47.19"
			}),
			/* @__PURE__ */ _jsx("polygon", {
				className: "icon-white",
				points: "54.54 29.5 66.73 36.62 66.99 50.57 54.54 57.8 42.18 50.59 42.18 37.13 54.54 29.5"
			}),
			/* @__PURE__ */ _jsx("polygon", {
				className: "icon-white",
				points: "82.31 12.6 91.93 18.22 92.14 29.23 82.31 34.93 77.23 31.96 72.56 24.54 72.56 18.63 82.31 12.6"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-outline",
				d: "M92.41,17.63l-9.56-5.52a1.08,1.08,0,0,0-1.07,0L72.3,17.59a1.07,1.07,0,0,0-.54.92V22A25.42,25.42,0,0,0,29.92,41.39a35.23,35.23,0,0,0,1.24,9l-7.26-4.2a1.36,1.36,0,0,0-1.35,0L7.74,54.72a1.35,1.35,0,0,0-.68,1.17V73a1.35,1.35,0,0,0,.68,1.17l14.9,8.6a1.38,1.38,0,0,0,1.35,0L38.8,74.22a1.35,1.35,0,0,0,.68-1.17V68.42A151.91,151.91,0,0,0,54.3,87.56a1.39,1.39,0,0,0,1.05.47,1.38,1.38,0,0,0,1-.47,148.88,148.88,0,0,0,15.36-20c6-9.66,9-18.47,9-26.17a25.57,25.57,0,0,0-.86-6.59l1.93,1.12a1.08,1.08,0,0,0,1.06,0l9.49-5.48a1.07,1.07,0,0,0,.54-.92v-11A1.08,1.08,0,0,0,92.41,17.63Zm-.26.43ZM22,65.28v14l-12.19-7v-14ZM38.8,54.78l-4.09-2.36a34.81,34.81,0,0,1-2-11A22.6,22.6,0,0,1,72.08,26.18c.39.42.77.87,1.13,1.33a23,23,0,0,1,1.9,2.87A19.3,19.3,0,0,1,76,32.2a22.31,22.31,0,0,1,2,9.19c0,4.29,0,17.32-22.63,43.12A127.64,127.64,0,0,1,39.48,62.93V56A1.35,1.35,0,0,0,38.8,54.78ZM81.31,24.65v8.49l-1.87-1.08-.56-.33a25.56,25.56,0,0,0-5-7.72V20.37ZM35.42,56l-12.1,7-12.2-7,12.1-7Zm1.35,2.34v14l-12.1,7v-14Zm53-39.74-7.35,4.24L75,18.51l7.36-4.24ZM90.8,20.4v8.49l-7.35,4.25V24.65Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M68.84,35,56.08,27.68a1.5,1.5,0,0,0-1.53,0L41.86,35a1.53,1.53,0,0,0-.76,1.32V51a1.56,1.56,0,0,0,.76,1.33l12.76,7.36a1.51,1.51,0,0,0,.77.21,1.49,1.49,0,0,0,.77-.21l12.68-7.32A1.53,1.53,0,0,0,69.6,51V36.37A1.53,1.53,0,0,0,68.84,35Zm-15,9.53v11.1l-9.7-5.59V39ZM65,36.37l-9.62,5.55-9.69-5.6,9.61-5.55ZM66.54,39v11.1l-9.62,5.55V44.57Z"
			})
		]
	})
});
export default SvgOrderPickingSm;
